/* import __COLOCATED_TEMPLATE__ from './bounce-selector.hbs'; */
import Component from '@glimmer/component';

export default class IssuesFormBounceSelectorComponent extends Component {}
